import * as yup from 'yup';
import { DeathRelatedInfoType } from '../../static/types/commonTypes/deathRelatedInfoType';

type ValidationResult = {
    isValid: boolean;
    errors: { [key: string]: string };
  };
  
export function validateRelatedInfo(input: DeathRelatedInfoType): ValidationResult {
    const errors: { [key: string]: string } = {};

    if (!input.dateOfDeath) {
        errors.dateOfDeath = "La date est requise";
    }

    if( !(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/.test(input.dateOfDeath))) {
      errors.dateOfDeath = "Format attendu JJ/MM/AAAA";
    }

    if( !input.city ){
      errors.city = "La ville et requise!"
    }

    if( input.abroad === false ){
      if( !input.postalCode ) errors.postalCode = "Le code postal est requis"
      if( !/^\d{5}$/.test( input.postalCode || '' ) ) errors.postalCode = "Le code postal doit contenir 5 chiffres"
    }

    if( input.abroad === true ){
      if( !input.country ) errors.country = "Le pays est requis"
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
}
  

const deathRelatedInfoValidationSchema = yup.object().shape({
  dateOfDeath: yup
    .string()
    .required('La date de décès est requise')
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/,
      'Format attendu JJ/MM/AAAA'
    ),

  abroad: yup.boolean().required('Le champ "à l’étranger" est requis'),

  postalCode: yup
    .string()
    .nullable()
    .when('abroad', ([abroad], schema) =>
      abroad === false
        ? schema.required('Le code postal est requis').matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres')
        : schema.nullable()
    ),

  country: yup
    .string()
    .nullable()
    .when('abroad', ([abroad], schema) =>
      abroad === true
        ? schema.required('Le pays est requis')
        : schema.nullable()
    ),

  city: yup
    .string()
    .nullable()
    .when('abroad', ([abroad], schema) =>
      abroad === true
        ? schema.required('La ville est requise')
        : schema.nullable()
    ),

  cities: yup.array().of(yup.string()).nullable(),
});

export default deathRelatedInfoValidationSchema;